module.exports = "./27778c442a7c9d8850e3a743d7feb705.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@sabre/aven-spark/icons/build/fonts/spark-icon-fill.svg
// module id = 1414
// module chunks = 0